import Vue from 'vue';

import SubscriptionDetail from './SubscriptionDetail.vue';
import Subscription from './Subscription.vue';

Vue.component('SubscriptionDetail', SubscriptionDetail);
Vue.component('Subscription', Subscription);
